// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"87e11a57","631":"66bc856b"}[chunkId] + ".chunk.css";
};